import { WflObject } from "../model/wfl/wflobject";
import { BodyInit } from "undici-types/fetch";


export interface IClient {

    /**
     * 
     * @returns true when logged in
     */
    isLoggedOn(): boolean;

    /**
     * 
     * @param configurationId 
     * @returns true when logged in
     */
    logon(configurationId: string): Promise<boolean>;

    getBaseUrl(): string;

    /**
     * @param studioUrl The 
     * @param appname The application name
     * @param username The WoodWing Studio username
     * @param password The WoodWing Studio password
     * @param requestId Optional: The requestID 
     * @param configurationId Optional: The configurationID
     * @returns The new or given ConfigurationId
     * @throws QqAwsServiceStudioClientClientError when the registration fails.
     */
    register(studioUrl: string, appname: string, username: string, password: string, requestId: string | undefined, configurationId: string | undefined): Promise<string>;


    unRegister(configurationId?: string): Promise<void>;

    /**
     * 
     * @param ids The brand id(s)
     * @param requestInfo What elements to retrieve. "PubChannels","States", "Categories"
     * @param forceNew When true, ignore local cache.
     * @param requestId 
     * @param configurationId 
     * @returns 
     */
    //getPublications(ids: string[], requestInfo? : string[], requestId?: string, configurationId?: string): Promise<Record<string, any>[]> ;
    getPublications(ids: string[], requestInfo?: string[], forceNew?: boolean, requestId?: string, configurationId?: string): Promise<Record<string, any>[]>;


    /**
     * 
     * @param forceNew When true create a new ticket instead of the cached ticket
     * @param requestId 
     * @param configurationId 
     * @returns 
     */
    getTicket(forceNew?: boolean, requestId?: string, configurationId?: string): Promise<string>;


    /**
     *
     * @param {string} publicationId
     * @param {string} type
     * @param {string} name
     * @returns {Promise<null|object>}
     */
    getStateByName(publicationId: string, type: string, name: string): Promise<null | object>




    createObjects(wflObjects: WflObject[], lock?: boolean): Promise<WflObject[]>

    getObjects(
        objectIds: string[],
        rendition: string,
        requestInfo: string[],
        lock: boolean,
        areas: string[]
    ): Promise<WflObject[]>

}